import platform from '../utils/client';
import { Actions } from './action';
var Client = /** @class */ (function () {
    function Client() {
        this.count = 0;
        this.appLink = {};
        this.connect('studio');
    }
    Client.prototype.connect = function (act, linkedFn) {
        // const act = arguments[0];
        if (platform.ios) {
            if (typeof act === 'object') {
                this.appLink.action = act.bridge;
                this.appLink.action.init();
                this.appLink.action.registerHandler('amapCallWebViewHandler', this.callbacks);
                if (this.linkedFn) {
                    this.linkedFn();
                }
            }
            else {
                window.ampTpl = act;
                document.addEventListener('WebViewJavascriptBridgeReady', this.connect.bind(this), false);
                this.linkedFn = linkedFn;
                return;
            }
        }
        else {
            if (typeof act === 'object') {
                this.appLink.action = {
                    send: function (arg, callback) {
                        var paramsStringify = JSON.stringify(arg);
                        if (callback) {
                            try {
                                window.jsInterface.invokeMethod('send', [
                                    paramsStringify,
                                    callback
                                ]);
                            }
                            catch (e) { }
                        }
                        else {
                            try {
                                window.jsInterface.invokeMethod('send', paramsStringify);
                            }
                            catch (e) { }
                        }
                    }
                };
                if (this.linkedFn) {
                    this.linkedFn();
                }
            }
            else {
                window.ampTpl = act;
                this.linkedFn = linkedFn;
                this.connect({});
                // document.addEventListener(
                //   'DOMContentLoaded',
                //   this.connect.bind(this),
                //   false
                // );
                return;
            }
        }
    };
    Client.prototype.callbacks = function (res) {
        try {
            if (res) {
                var _cbName = res._action;
                if (_cbName) {
                    this.fnPool[_cbName].call(null, res.data ? res.data : res);
                    delete this.fnPool[_cbName];
                }
            }
            else {
                window.console.error('未知错误');
            }
        }
        catch (e) { }
    };
    Client.prototype.setupWebViewJavascriptBridge = function (callback) {
        if (window.WebViewJavascriptBridge) {
            return callback(window.WebViewJavascriptBridge);
        }
        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe);
        }, 0);
    };
    Client.prototype.sendMsg = function (params) {
        if (platform.ios) {
            this.setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler(params.action, { params: params.params }, function () { });
            });
        }
        else if (platform.android) {
            var _action = params._action;
            if (_action && typeof _action === 'function') {
                var _cbName = '_action' + this.count++;
                this.fnPool[_cbName] = _action;
                params._action = _cbName;
            }
            this.appLink.action.send(params);
        }
    };
    Client.prototype.getUserInfo = function (fn) {
        this.sendMsg({
            action: 'getUserInfo',
            _action: function (res) {
                fn(res);
            }
        });
    };
    Client.prototype.jump2Login = function (fn) {
        var params = {
            action: 'jump2Login'
        };
        if (fn) {
            params._action = fn;
        }
        this.sendMsg(params);
    };
    Client.prototype.shareInfo = function (params) {
        if (platform.ios) {
            this.setupWebViewJavascriptBridge(function (bridge) {
                bridge.registerHandler('shareInfo', function (data, responseCallback) {
                    responseCallback(params);
                });
            });
        }
        else {
            this.sendMsg({
                action: 'shareInfo',
                params: params
            });
        }
    };
    Client.prototype.saveImage = function (params) {
        this.sendMsg({
            action: 'saveImage',
            params: params
        });
        if (params.saveImageCallbacks) {
            // 安卓注册保存图片回调
            window.saveImageCallbacks = params.saveImageCallbacks;
            // ios注册保存图片回调
            this.setupWebViewJavascriptBridge(function (bridge) {
                bridge.registerHandler('saveImageCallback', function (data, responseCallback) {
                    params.saveImageCallbacks(data);
                    responseCallback(params);
                });
            });
        }
    };
    // 分享到微信
    Client.prototype.webShareImage = function (params) {
        this.sendMsg({
            action: 'web_shareImage',
            params: params
        });
        /**
         * 只有1.9.1版本之后的客户端能注册微信分享回调,且只有用户未安装微信客户端才会触发回调
         * 返回的数据: responseData: {
         *    result: 0  // 1: 成功, 0:失败
         *    type: 0 // 0: 未安装微信
         * }
         *
         */
        if (params.webShareImageCallbacks) {
            // 安卓注册分享微信回调
            window.webShareImageCallbacks = params.webShareImageCallbacks;
            // ios注册分享微信回调
            this.setupWebViewJavascriptBridge(function (bridge) {
                bridge.registerHandler('webShareImageCallbacks', function (data, responseCallback) {
                    params.webShareImageCallbacks(data);
                    responseCallback(params);
                });
            });
        }
    };
    /**
     * 分享链接到微信
     * @param {WebShareUrl} params 分享配置
     * @param {string}  paramswebShareUrlCallbacks 分享回调
     */
    Client.prototype.webShareUrl = function (params) {
        this.sendMsg({
            action: 'web_shareUrl',
            params: params
        });
        if (params.webShareUrlCallbacks) {
            // 安卓注册分享微信回调
            window.webShareUrlCallbacks = params.webShareUrlCallbacks;
            // ios注册分享微信回调
            this.setupWebViewJavascriptBridge(function (bridge) {
                bridge.registerHandler('webShareUrlCallbacks', function (data, responseCallback) {
                    params.webShareUrlCallbacks(data);
                    responseCallback(params);
                });
            });
        }
    };
    /**
     * 打开微信首页
     */
    Client.prototype.openWechat = function (params) {
        this.sendMsg({
            action: 'openWechat',
            params: params
        });
        if (params.openWechatCallbacks) {
            // 安卓注册打开微信回调
            window.openWechatCallbacks = params.openWechatCallbacks;
            // ios注册打开微信回调
            this.setupWebViewJavascriptBridge(function (bridge) {
                bridge.registerHandler('saveImageCallback', function (data, responseCallback) {
                    params.openWechatCallbacks(data);
                    responseCallback(params);
                });
            });
        }
    };
    /**
     * 唤起原生相册兼容ios 安卓
     */
    Client.prototype.getImage = function (params) {
        this.sendMsg({
            action: 'getImage',
            params: params
        });
        if (params.sendImageCallbacks) {
            // 安卓注册获取图片信息回调
            window.sendImage = params.sendImageCallbacks;
            // ios注册获取图片信息回调
            this.setupWebViewJavascriptBridge(function (bridge) {
                bridge.registerHandler('sendImage', function (data, responseCallback) {
                    params.sendImageCallbacks(data);
                    responseCallback(params);
                });
            });
        }
    };
    /**
     * 返回回调
     */
    Client.prototype.needControlBack = function (params) {
        this.sendMsg({
            action: 'needControlBack',
            params: params
        });
        if (params.showCustomDialog) {
            // 安卓返回回调
            window.showCustomDialog = params.showCustomDialog;
            // ios返回回调
            this.setupWebViewJavascriptBridge(function (bridge) {
                bridge.registerHandler('showCustomDialog', function (data, responseCallback) {
                    params.showCustomDialog(data);
                    responseCallback(params);
                });
            });
        }
    };
    /**
     * 分享微博
     */
    Client.prototype.shareWeiBo = function (params) {
        this.sendMsg({
            action: 'shareWeiBo',
            params: params
        });
    };
    /**
     * 分享Messenger
     */
    Client.prototype.shareMessenger = function (params) {
        this.sendMsg({
            action: 'shareMessenger',
            params: params
        });
    };
    /**
     * 分享Whatsapp
     */
    Client.prototype.shareWhatsapp = function (params) {
        this.sendMsg({
            action: 'shareWhatsapp',
            params: params
        });
    };
    /**
     * 分享 更多
     */
    Client.prototype.shareGetMore = function (params) {
        this.sendMsg({
            action: 'shareGetMore',
            params: params
        });
    };
    /**
     * 分享小程序 更多
     */
    Client.prototype.webShareApplets = function (params) {
        this.sendMsg({
            action: 'webShareApplets',
            params: params
        });
    };
    /**
     * 进入教室
     */
    Client.prototype.showLive = function (params) {
        this.sendMsg({
            action: 'showLive',
            params: params
        });
    };
    /**
     * 检查录音权限
     */
    Client.prototype.requestAudioAuthorization = function (params) {
        this.sendMsg({
            action: 'requestAudioAuthorization',
            params: params
        });
        if (params.receiveAudioAuthorization) {
            // 安卓注册分享微信回调
            window.receiveAudioAuthorization = params.receiveAudioAuthorization;
            // ios注册分享微信回调
            this.setupWebViewJavascriptBridge(function (bridge) {
                bridge.registerHandler('receiveAudioAuthorization', function (data, responseCallback) {
                    params.receiveAudioAuthorization(data);
                    responseCallback(params);
                });
            });
        }
    };
    /**
     * 开始录音
     */
    Client.prototype.startRecordAudio = function (params) {
        this.sendMsg({
            action: 'startRecordAudio',
            params: params
        });
    };
    /**
     * 结束录音权限
     */
    Client.prototype.stopRecordAudio = function (params) {
        this.sendMsg({
            action: 'stopRecordAudio',
            params: params
        });
        if (params.receiveStopRecordAudio) {
            // 安卓注册分享微信回调
            window.receiveStopRecordAudio = params.receiveStopRecordAudio;
            // ios注册分享微信回调
            this.setupWebViewJavascriptBridge(function (bridge) {
                bridge.registerHandler('receiveStopRecordAudio', function (data, responseCallback) {
                    params.receiveStopRecordAudio(data);
                    responseCallback(params);
                });
            });
        }
    };
    /**
     * 上传曲谱
     */
    Client.prototype.liveroomUploadScore = function (params) {
        this.sendMsg({
            action: 'liveroomUploadScore',
            params: params
        });
    };
    /**
     * 注销
     */
    Client.prototype.appReset = function () {
        this.sendMsg({
            action: 'appReset'
        });
    };
    return Client;
}());
var _loop_1 = function (key) {
    Object.defineProperty(Client.prototype, key, {
        value: function (params) {
            if (params === void 0) { params = {}; }
            this.sendMsg({
                action: key,
                params: params
            });
            /**
             * 调用jsbridge之后，原生调用callback回调传参给js
             * callbackName：[原生回调js函数名],由于安卓是直接调用window函数，函数名称不能跟window对象私有函数名重复。
             * callbackFn: 回调js方法，自己写的调用回调的js逻辑
             */
            var callbackName = params.callbackName;
            var callbackFn = params.callbackFn;
            if (callbackName && callbackFn && typeof callbackFn === 'function') {
                // 安卓注册回调
                // @ts-ignore
                window[callbackName] = callbackFn;
                // ios注册回调
                this.setupWebViewJavascriptBridge(function (bridge) {
                    bridge.registerHandler(callbackName, function (data, responseCallback) {
                        callbackFn(data);
                        responseCallback(params);
                    });
                });
            }
        }
    });
};
for (var key in Actions) {
    _loop_1(key);
}
var jsbridge = null;
if (platform.msb1v1app) {
    jsbridge = new Client();
}
export default jsbridge;
//# sourceMappingURL=index.js.map